import { render, staticRenderFns } from "./EventSettingsMenu.vue?vue&type=template&id=6f498f34&scoped=true&"
import script from "./EventSettingsMenu.vue?vue&type=script&lang=js&"
export * from "./EventSettingsMenu.vue?vue&type=script&lang=js&"
import style0 from "./EventSettingsMenu.vue?vue&type=style&index=0&id=6f498f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f498f34",
  null
  
)

export default component.exports